export default '/favorites';
